/** Design tokens from SoftAI template — use in styled-components */
export const THEME = {
	bg: '#020106',
	panel: '#12091a',
	panelSoft: '#1b0c27',
	line: 'rgba(246, 142, 255, 0.16)',
	text: '#fff7ff',
	muted: '#d8bde4',
	soft: '#a478b7',
	pink: '#ff4df2',
	violet: '#b026ff',
	peach: '#ffb26c',
	gold: '#ffd36b',
	green: '#54d6a1',
	error: '#f46060',
	glow: '0 0 28px rgba(214, 42, 255, 0.46)',
	shadow: '0 24px 70px rgba(0, 0, 0, 0.55)',
	gradientDark: 'linear-gradient(135deg, #020106 0%, #12091a 100%)',
	topbarHeight: '76px',
	mobileTopbarHeight: '58px',
	topbarBg: '#07030c',
	mobileNavHeight: '56px',
	mobileBreakpoint: '760px',
	mobileGutter: '16px',
	sidebarWidth: '92px',
	fontApp:
		'Manrope, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
	fontDisplay:
		'Manrope, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
	fontBody:
		'Manrope, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
	bodyBackground:
		'linear-gradient(104deg, transparent 0%, transparent 35%, rgba(176, 38, 255, 0.14) 46%, rgba(255, 77, 242, 0.08) 55%, transparent 70%), linear-gradient(112deg, transparent 0%, transparent 52%, rgba(255, 211, 107, 0.045) 62%, transparent 76%), radial-gradient(circle at 48% -10%, rgba(176, 38, 255, 0.26), transparent 34%), radial-gradient(circle at 92% 10%, rgba(255, 77, 242, 0.12), transparent 28%), #020106',
	gradientPrimary:
		'linear-gradient(135deg, #b026ff, #ff4df2 58%, #ffb26c)',
	gradientHighlight:
		'linear-gradient(135deg, #ff4df2 0%, #c680ff 44%, #ffd36b 100%)',
};
